module.exports = __webpack_public_path__ + "img/test_month.8d85d4ff.jpg";